// Include phones and tablets supported by the browser install prompt.
function isMobileDevice() {
  const userAgent = navigator.userAgent || '';
  const isAndroid = /Android/i.test(userAgent);
  const isAppleMobile = /iPhone|iPad|iPod|Macintosh.*Mobile/i.test(userAgent);
  const isOtherMobile = /Windows Phone|IEMobile|webOS|BlackBerry|Opera Mini/i.test(userAgent);

  // Android tablets report `userAgentData.mobile === false`, even though
  // Chrome supports the PWA install prompt on them.
  if (isAndroid || isAppleMobile || isOtherMobile) {
    return true;
  }

  return Boolean(
    navigator.userAgentData &&
    typeof navigator.userAgentData.mobile === 'boolean' &&
    navigator.userAgentData.mobile
  );
}

window.isMobileDevice = isMobileDevice;

if ('serviceWorker' in navigator && window.location.hostname === 'www.void-scourge.com') {
  navigator.serviceWorker.register('/service-worker.js').then((registration) => {
    registration.update();
  });
}

let deferredInstallPrompt;

if (isMobileDevice()) {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;

    const installButton = document.getElementById('install-app');
    if (installButton) {
      try {
        var cnt = parseInt(localStorage.getItem('matches_played') || '0', 10) || 0;
        if (cnt >= 2) {
          installButton.style.display = 'block';
        }
      } catch(e) {}
      installButton.addEventListener('click', () => {
        deferredInstallPrompt.prompt();
        deferredInstallPrompt.userChoice.then((choiceResult) => {
          installButton.style.display = 'none';
          deferredInstallPrompt = null;
        });
      }, { once: true });
    }
  });

  window.addEventListener('appinstalled', () => {
    const installButton = document.getElementById('install-app');
    if (installButton) installButton.style.display = 'none';
    if (window.gtag) { gtag('event', 'pwa_install'); }
  });
}
